import type { Messages } from './en'

export const ja: Messages = {
  'lang.label': '言語',
  'lang.en': 'English',
  'lang.ja': '日本語',
  'lang.zhHant': '繁體中文',

  'common.back': '← 戻る',
  'common.cancel': 'キャンセル',
  'common.save': '保存',
  'common.saving': '保存中…',
  'common.loading': '読み込み中…',
  'common.previous': '前へ',
  'common.next': '次へ',
  'common.dismiss': '閉じる',
  'common.ok': 'OK',
  'common.clear': 'クリア',
  'common.play': '再生',
  'common.pause': '一時停止',
  'common.start': '開始',
  'common.end': '終了',
  'common.technique': '技',
  'common.techniques': '技一覧',
  'common.status': '状態',
  'common.configured': '設定済み',
  'common.unset': '未設定',
  'common.opensNewTab': '（新しいタブで開きます）',

  'library.eyebrow': 'Judo',
  'library.title': '形 KATA',
  'library.subtitle': '形を選んでください',
  'library.kodokan': 'KODOKAN',
  'library.dataLink': 'ローカルデータの書き出し・取り込み・リセット',
  'library.manualLink': '使い方ガイド',
  'library.homeScreenTitle': 'ホーム画面に追加',
  'library.homeScreenBody':
    'このアプリをホーム画面に追加すると、すばやく開けて全画面で練習できます。',
  'library.homeScreenInstall': 'アプリをインストール',
  'library.homeScreenInstalling': 'インストールを開いています…',
  'library.homeScreenIosStep1': 'Safari でこのサイトを開きます。',
  'library.homeScreenIosStep2': '共有ボタン（四角と矢印）をタップします。',
  'library.homeScreenIosStep3': '「ホーム画面に追加」を選び、追加をタップします。',
  'library.homeScreenAndroidStep1': 'Chrome（または Edge）でこのサイトを開きます。',
  'library.homeScreenAndroidStep2': 'ブラウザのメニュー（⋮）をタップします。',
  'library.homeScreenAndroidStep3':
    '「アプリをインストール」または「ホーム画面に追加」を選び、確定します。',
  'library.waitlistTitle': 'クラウド同期',
  'library.waitlistBody':
    '端末間の有料バックアップ（任意）。無料のローカル利用はそのままです。メリットと予定価格を確認し、ウェイトリストに参加できます。',
  'library.waitlistLearnMore': 'クラウド同期について知る',
  'library.feedbackTitle': 'フィードバック',

  'cloudSync.documentTitle': 'クラウド同期 | 柔道形練習ツール',
  'cloudSync.backToLibrary': '← 形一覧に戻る',
  'cloudSync.openData': 'ローカルの書き出し / 読み込み',
  'cloudSync.openDisclaimer': '免責事項',
  'cloudSync.eyebrow': '任意の有料プラン',
  'cloudSync.title': 'クラウド同期',
  'cloudSync.subtitle':
    '形のメモ、アンカー、設定を複数端末で続けられます。無料のローカル練習はそのままです。',
  'cloudSync.status':
    'ウェイトリスト段階 — まだ販売していません。十分な申込があれば、同期機能を作ります。',
  'cloudSync.compareTitle': '無料とクラウド同期',
  'cloudSync.compareLead':
    'クラウド同期はあなた自身の練習データをバックアップします。形の内容や YouTube 動画の解除ではありません。',
  'cloudSync.freeTitle': 'この端末では常に無料',
  'cloudSync.freeItem1': '形の練習と採点はすべて利用可 — アカウント不要',
  'cloudSync.freeItem2': 'YouTube 参照、アンカー、メモ、お気に入りは IndexedDB に保存',
  'cloudSync.freeItem3': 'データ画面での JSON の手動書き出し・読み込み',
  'cloudSync.freeItem4': '初回訪問後はアプリシェルをオフラインでも利用可能',
  'cloudSync.paidTitle': 'クラウド同期あり',
  'cloudSync.paidItem1': '個人メタデータのクラウドへの自動バックアップ',
  'cloudSync.paidItem2': 'サインイン後、スマホとノート PC で同じ設定',
  'cloudSync.paidItem3': 'ブラウザ消去や端末変更時の復元',
  'cloudSync.paidItem4': '設定も形データと一緒に同期',
  'cloudSync.notIncludedTitle': '購入対象外のもの',
  'cloudSync.notIncludedBody':
    'YouTube 動画は無料のまま、利用者自身が用意します。v1 のクラウド同期は動画ホスティングや形メディアの販売、コーチ／チーム共有ではありません。解約すると同期は止まりますが、端末上のローカルデータは残ります。',
  'cloudSync.howTitle': '想定する流れ',
  'cloudSync.howLead': 'ウェイトリストの条件を満たし、課金を開始したあとの予定フローです。',
  'cloudSync.howStep1': 'マジックリンクでサインイン（メール、パスワードなし）。',
  'cloudSync.howStep2': 'クラウド同期に加入すると、ローカル保存のあとにバックグラウンドで同期します。',
  'cloudSync.howStep3':
    'ローカルデータが正です。端末間で食い違う場合は、最新のクラウド書き込みが優先され、短い通知を出します。',
  'cloudSync.pricingTitle': '予定価格',
  'cloudSync.pricingLead': '有料プランの機能は同じです。請求周期だけが異なります。',
  'cloudSync.planMonthlyName': '月額',
  'cloudSync.planMonthlyPrice': 'US$2',
  'cloudSync.planMonthlyPeriod': '/ 月',
  'cloudSync.planHalfYearName': '半年',
  'cloudSync.planHalfYearPrice': 'US$11',
  'cloudSync.planHalfYearPeriod': '/ 6 か月',
  'cloudSync.planHalfYearNote': '稽古シーズン向け',
  'cloudSync.planYearlyName': '年額',
  'cloudSync.planYearlyPrice': 'US$20',
  'cloudSync.planYearlyPeriod': '/ 年',
  'cloudSync.planYearlyNote': 'いちばんお得',
  'cloudSync.pricingPhilosophy':
    'ホスティングとログイン用メールの費用をまかなえるよう設定し、無料のローカルアプリを続けられるようにしています。お支払い対象はデータの同期であり、YouTube や形のコンテンツではありません。',
  'cloudSync.waitlistTitle': 'ウェイトリストに参加',
  'cloudSync.waitlistBody':
    '興味があることをメールで知らせてください。少なくとも 10 人の申込があれば、クラウド同期を作ります。これは購入ではありません。',
  'cloudSync.waitlistCta': 'メールでウェイトリストに参加',
  'cloudSync.waitlistSubject': 'クラウド同期ウェイトリスト',
  'cloudSync.waitlistEmailBody':
    'こんにちは。\n\n柔道形アプリのクラウド同期ウェイトリストに参加したいです。\n\nよろしくお願いします。',

  'library.feedbackBody':
    'このアプリについてのご意見、不具合、ご質問は、開発者へのメールでお寄せください。',
  'library.feedbackCta': 'メールでフィードバックを送る',
  'library.feedbackSubject': '柔道形アプリへのフィードバック',
  'library.disclaimer':
    '個人用の動画URLとアンカーはこの端末のみに保存されます。ブラウザデータを消すと失われることがあります。動画再生にはYouTubeへの接続が必要です。',

  'practice.changeKata': '← 形を変更',
  'practice.editVideoAnchors': '動画を編集',
  'practice.configureVideo': '動画を設定',
  'practice.judgePerformance': '演武を採点',
  'practice.pastScores': '過去の得点',
  'practice.backToJudging': '← 採点に戻る',
  'practice.label': '練習',
  'practice.selectTechnique': '技を選択',
  'practice.selectTechniquePrompt': '動きを見る技を選択してください。',
  'practice.category': '分類',
  'practice.timingNotSet': 'タイミング未設定',
  'practice.timingNotSetFor':
    '{name} のタイミングが未設定です。動画全体を見るか、編集画面で開始と終了を設定できます。',
  'practice.addVideoTitle': '動画を追加',
  'practice.addVideoBody':
    '{kata} のYouTube参照が未設定です。技の区間練習をするにはオンライン動画を設定してください。',
  'practice.addVideoBodyScoring':
    '{kata} のYouTube参照はまだありません。採点は今すぐできます。区間練習や参考動画を見るときは動画を追加してください。',
  'practice.addVideo': '動画を追加',
  'practice.editAnchors': 'アンカーを編集',
  'practice.segment': '区間',
  'practice.playbackGroup': '区間再生',
  'practice.playSegment': '区間を再生',
  'practice.playing': '再生中…',
  'practice.replay': 'もう一度',
  'practice.playVideo': '動画を再生',
  'practice.meta': '{count} 技 · 動画ID {videoId}',
  'practice.disclaimer':
    'URLとアンカーはこの端末に保存されます（動画本体ではありません）。再生にはインターネットが必要です。',
  'practice.loadError': 'ローカルデータを読み込めませんでした。',

  'setup.editTitle': '動画を編集',
  'setup.configureTitle': '動画を設定',
  'setup.bannerHint': 'オンラインYouTube参照',
  'setup.urlLabel': 'YouTube URL',
  'setup.urlHint': 'youtube.com/watch、youtu.be、または埋め込みURL。アップロードはありません。',
  'setup.titleLabel': '参照タイトル（任意）',
  'setup.titleHint': 'タイトルのみ変更すると既存の技タイミングは保持されます。',
  'setup.titlePlaceholder': '{kata} の参照',
  'setup.preview': 'プレビュー',
  'setup.unsaved': '未保存の変更',
  'setup.identityWarning':
    'この動画IDは保存済みの参照と異なります{timings}。保存すると既存の技タイミングはクリアされ、誤って再利用されません。「差し替えを確認」をもう一度押して続行するか、タイトルのみ編集して現在の動画のタイミングを保持してください。',
  'setup.timingsCount': '（技タイミング {count} 件）',
  'setup.confirmReplace': '差し替えを確認',
  'setup.saveReference': '参照を保存',
  'setup.continue': '続行',
  'setup.removeVideo': '動画を削除',
  'setup.removing': '削除中…',
  'setup.removeConfirm':
    '{kata} の保存済みYouTube参照を削除しますか？この動画の技タイミングは削除されます。技カタログは影響を受けません。メモとお気に入りは残ります。',
  'setup.discardConfirm': '未保存の変更を破棄しますか？',
  'setup.saveFailed': '保存に失敗しました。ローカルデータは更新されていません。',
  'setup.removeFailed': '削除に失敗しました。ローカルデータは更新されていません。',
  'setup.disclaimer':
    'URLはこの端末に保存されます。動画はダウンロードされません。再生にはインターネットが必要です。',

  'youtube.error.empty': 'YouTube URLを入力してください。',
  'youtube.error.invalid': '有効なYouTube URL（youtube.com または youtu.be）を入力してください。',
  'youtube.error.unsupportedHost': 'YouTube URLのみ対応しています。',
  'youtube.error.missingId': 'そのURLから有効なYouTube動画IDを見つけられませんでした。',
  'youtube.error.invalidId': '無効な動画IDです。',
  'youtube.error.html5': 'HTML5プレーヤーエラーです。',
  'youtube.error.notFound': '動画が見つからないか非公開です。',
  'youtube.error.embedDisabled': 'この動画は埋め込みが無効です。',
  'youtube.error.playback': '再生エラー（コード {code}）。別の動画を試してください。',
  'youtube.error.loadFailed': 'YouTubeプレーヤーを読み込めませんでした。',
  'youtube.noVideo': '動画が設定されていません。',
  'youtube.loadingPlayer': 'プレーヤーを読み込み中…',
  'youtube.loadVideo': '動画を読み込む',
  'youtube.loadVideoHint':
    '通信量を節約します。読み込みまたは再生するまでストリームは開始しません。',
  'youtube.dataSaver.title': 'モバイルデータを節約',
  'youtube.dataSaver.on': 'オン',
  'youtube.dataSaver.off': 'オフ',
  'youtube.dataSaver.explanation':
    'オンのときは軽量なポスターを表示し、動画を読み込む・プレビュー・再生するまでYouTubeストリームを開始しません。技一覧を見るだけでは動画はダウンロードされません。オフのときは参照が表示されるとすぐにプレーヤーを読み込みます。',
  'youtube.dataSaver.explanationShort':
    'オン: 先にポスター、読み込みまたは再生後にストリーム。オフ: プレーヤーをすぐ読み込み。',
  'youtube.dataSaver.note':
    '動画ファイル自体はダウンロードも保存もしません。再生にはインターネットが必要です。この設定はこの端末に保存され、JSONエクスポートに含まれます。',
  'youtube.offline':
    'オフラインのため再生できません。この端末に保存されたURLとアンカーは編集できます。',
  'youtube.referenceVideo': '参照動画',

  'anchors.pageTitle': '技のアンカー',
  'anchors.editorTitle': 'アンカー編集',
  'anchors.needVideo': 'アンカーを編集する前にYouTube参照を設定してください。',
  'anchors.configureVideo': '動画を設定',
  'anchors.changeRemoveVideo': '動画の変更 / 削除',
  'anchors.heroMeta': '{kata} · {configured}/{total} 設定済み',
  'anchors.allTechniques': 'すべての技',
  'anchors.sideHint': '演武順 · 任意の技を編集',
  'anchors.durationPending':
    '長さの検証は保留中です — プレーヤーが長さを返すまで終了位置を動画長と照合できません。開始 < 終了の有効な範囲は保存できます。',
  'anchors.overlapWarning': '重複警告（ブロックしません）: この範囲は {names} と重なります。',
  'anchors.unsaved': '未保存のタイミング変更',
  'anchors.boundTo': '動画 {videoId} に紐付け',
  'anchors.overview': 'タイミング一覧',
  'anchors.startBeforeEnd': '開始は終了より前である必要があります。',
  'anchors.endAfterStart': '終了は開始より後である必要があります。',
  'anchors.startWithinDuration': '開始は動画の長さの範囲内である必要があります。',
  'anchors.endWithinDuration': '終了は動画の長さの範囲内である必要があります。',
  'anchors.setBothFirst': '先に開始と終了の両方を設定してください。',
  'anchors.setBothBeforeSave': '保存する前に開始と終了の両方を設定してください。',
  'anchors.saved': 'この端末に保存しました。',
  'anchors.savedPending':
    'この端末に保存しました。プレーヤーが長さを返すまで長さの検証は保留です。',
  'anchors.overlapNote': ' 重複警告（ブロックしません）: {names}。',
  'anchors.clearConfirm':
    'この技の開始/終了をクリアしますか？保存済みのタイミングは削除されます。',
  'anchors.cleared': 'この端末でタイミングをクリアしました。',
  'anchors.clearFailed': 'クリアに失敗しました。ローカルデータは更新されていません。',
  'anchors.discardConfirm': '未保存のタイミング変更を破棄しますか？',
  'anchors.discardTechniqueConfirm': 'この技の未保存のタイミング変更を破棄しますか？',
  'anchors.loadError': '保存済みの参照を読み込めませんでした。',
  'anchors.saveFailed': '保存に失敗しました。ローカルデータは更新されていません。',
  'anchors.disclaimer':
    'アンカー、メモ、お気に入りはこのYouTube参照に対してこの端末に保存されます。動画を差し替えるとタイミングはクリアされます（メモ/お気に入りは残ります）。動画本体はダウンロードされません。',

  'controls.captureGroup': '現在時刻を取り込み',
  'controls.setStartHere': 'ここを開始に',
  'controls.setEndHere': 'ここを終了に',
  'controls.jumpGroup': 'アンカーへ移動',
  'controls.jumpStart': '開始へ移動',
  'controls.jumpEnd': '終了へ移動',
  'controls.seekGroup': 'シーク操作',
  'controls.previewSegment': '区間プレビュー',

  'timeline.start': '開始 {time}',
  'timeline.end': '終了 {time}',
  'timeline.now': '現在 {time}',
  'timeline.duration': '長さ {time}',
  'timeline.durationPending': '長さ保留 — プレーヤーが長さを返すまで検証は未完了です',
  'timeline.startHandle': '開始アンカー {time}。矢印キーで調整できます。',
  'timeline.endHandle': '終了アンカー {time}。矢印キーで調整できます。',
  'timeline.playhead': '再生位置 {time}',

  'personal.title': '個人用',
  'personal.favourite': 'お気に入り',
  'personal.favouriteOn': '★ お気に入り',
  'personal.favouriteOff': '☆ お気に入り',
  'personal.noteLabel': '{name} のメモ',
  'personal.notePlaceholder': 'メモ（この端末に保存）',
  'personal.noteHint':
    'リッチテキストはこの端末に保存されます。メディア埋め込みは無効で、HTMLとしては実行されません。',
  'personal.saveNote': 'メモを保存',
  'personal.deleteNote': 'メモを削除',
  'personal.unsavedNote': '未保存のメモ',
  'personal.loading': '個人データを読み込み中…',
  'personal.loadError': '個人データを読み込めませんでした。',
  'personal.noteSaved': 'この端末にメモを保存しました。',
  'personal.noteCleared': 'この端末でメモをクリアしました。',
  'personal.noteDeleted': 'この端末でメモを削除しました。',
  'personal.noteSaveFailed': 'メモの保存に失敗しました。ローカルデータは更新されていません。',
  'personal.noteDeleteConfirm': '{name} のメモを削除しますか？',
  'personal.noteDeleteFailed': 'メモを削除できませんでした。',
  'personal.favouriteFailed': 'お気に入りを更新できませんでした。',
  'personal.showNotes': 'メモ',
  'personal.hideNotes': 'メモを隠す',
  'personal.fullScreenNote': '全画面メモ',
  'personal.notesPanel': '技のメモ',
  'personal.closeNotes': 'メモを閉じる',

  'manual.eyebrow': 'ガイド',
  'manual.title': '使い方',
  'manual.subtitle':
    '自分のYouTube参照を設定し、技のアンカーを付け、形を練習し、演武を採点できます。アカウントは不要です。',
  'manual.tocTitle': 'このガイドの内容',
  'manual.backToLibrary': '形一覧に戻る',
  'manual.openData': 'ローカルデータを開く',

  'manual.overviewTitle': 'このアプリでできること',
  'manual.overviewLead':
    'ローカル優先の形練習コンパニオンです。YouTube参照はあなたが用意し、タイミング・メモ・お気に入り・練習採点はこのブラウザに保存されます。',
  'manual.overviewStep1': '講道館の7つの形を、演武順の技一覧で閲覧できます。',
  'manual.overviewStep2':
    '好きなYouTube URLを貼り付けます — 初期搭載の動画カタログはありません。',
  'manual.overviewStep3':
    '各技に開始・終了を付けて区間再生で練習するか、IJF風の基準で演武を採点します（動画再生にはネットが必要）。',

  'manual.chooseTitle': '形を選ぶ',
  'manual.chooseLead': 'ホームの形一覧から始めます。カードを開くとその形の練習画面になります。',
  'manual.chooseStep1': 'ホームで7つの形カードから1つを選びます。',
  'manual.chooseStep2': '別の形に切り替えるときは「形を変更」で一覧に戻れます。',
  'manual.chooseStep3': 'カテゴリがある形では、先にカテゴリを選び、次に技を選びます。',

  'manual.videoTitle': 'YouTube参照を追加する',
  'manual.videoLead':
    '練習には形ごとにオンラインのYouTube参照が1つ必要です。設定は日常の視聴画面とは分けています。',
  'manual.videoStep1': '形画面で「動画を設定」または「動画を編集」を開きます。',
  'manual.videoStep2':
    'youtube.com / youtu.be / 埋め込みURLを貼ります。タイトルは任意です。',
  'manual.videoStep3': 'プレビューしてから保存します。URLはこの端末のみに保存されます。',
  'manual.videoStep4':
    '差し替えや削除も同じ設定画面から確認付きで行います。別の動画IDに替えると技タイミングはクリアされます。',
  'manual.videoNote':
    'アップロードや端末内の動画ファイルは非対応です。再生は常にYouTubeからストリーミングします。',
  'manual.demoFiguresTitle': '参考用のデモ動画',
  'manual.figDemoAlt':
    'Perfect Nage No Kata のYouTubeサムネイル — 開くか、動画設定に貼って試せる例',
  'manual.figDemoCaption': 'デモ — Perfect Nage No Kata（YouTube）',
  'manual.figDemoL1':
    '画像をタップすると https://www.youtube.com/watch?v=URH_OKRN9bs が新しいタブで開きます。',
  'manual.figDemoL2':
    'そのURLを「動画を設定」に貼れば、この参照でアンカー付けと区間練習を試せます。',

  'manual.anchorsTitle': '技のアンカーを付ける',
  'manual.anchorsLead':
    'アンカーは、保存した参照動画上での1つの技の開始時刻と終了時刻です。',
  'manual.anchorsStep1': '「動画を編集」を開き、一覧から技を選びます。',
  'manual.anchorsStep2':
    '±1秒 / ±5秒、再生/一時停止、またはタイムラインのトラックをタップして位置を合わせます。',
  'manual.anchorsStep3':
    '「ここで開始」「ここで終了」を使うか、時刻を入力します（mm:ss または hh:mm:ss）。',
  'manual.anchorsStep4':
    'タイムライン上の開始・終了ハンドルをドラッグできます（交差不可）。区間プレビューで確認します。',
  'manual.anchorsStep5':
    '問題なければ保存します。ほかの技は必要なときまで未設定のままで構いません。',
  'manual.anchorsNote':
    '未保存の編集があるときは離脱前に確認が出ます。精度はYouTubeプレイヤーのベストエフォートであり、フレーム単位ではありません。',

  'manual.figuresTitle': '設定フローの画面例',
  'manual.figOpenAlt': '動画未設定時の形練習画面。「動画を設定」と「動画を追加」が見える',
  'manual.figOpenCaption': '1 — 形の練習画面から設定を開く',
  'manual.figOpenL1': 'ヘッダーの「動画を設定」を使います。',
  'manual.figOpenL2': '動画未設定のときは「動画を追加」でも同じ設定フローに入れます。',
  'manual.figOpenL3': '技は選べます。タイミング付けは動画保存後に行います。',

  'manual.figVideoAlt': '動画設定画面。YouTube URL欄、任意タイトル、プレビュー',
  'manual.figVideoCaption': '2 — YouTube参照を貼り付ける',
  'manual.figVideoL1': 'youtube.com / youtu.be / 埋め込みURLを貼ります。',
  'manual.figVideoL2': 'タイトルは任意 — タイトルだけの編集なら既存タイミングは残ります。',
  'manual.figVideoL3': 'プレビューしてから保存します。URLはこの端末に保存されます。',

  'manual.figEditorAlt': 'アンカー編集画面。技一覧、動画プレイヤー、開始/終了タイムライン',
  'manual.figEditorCaption': '3 — アンカー編集の画面構成',
  'manual.figEditorL1': '一覧からタイミングを付ける技を選びます。',
  'manual.figEditorL2': 'プレイヤーで参照を確認します（インターネットが必要）。',
  'manual.figEditorL3': 'タイムライン上の開始（S）・終了（E）ハンドルをドラッグします（交差不可）。',

  'manual.figMarkAlt': 'アンカー操作。タイムライン、ここで開始/終了、シーク、プレビュー、保存',
  'manual.figMarkCaption': '4 — 付けて、プレビューして、保存',
  'manual.figMarkL1': 'タイムライン上の開始・現在・終了・長さを確認します。',
  'manual.figMarkL2': 'S/Eハンドルをドラッグするか、「ここで開始/終了」や時刻入力で設定します。',
  'manual.figMarkL3': '±1秒 / ±5秒で微調整し、「区間プレビュー」で範囲を確認します。',
  'manual.figMarkL4': '問題なければ「保存」。キャンセルは未保存の編集を破棄します。',

  'manual.dataSaverTitle': 'モバイルデータを節約（YouTube）',
  'manual.dataSaverLead':
    '読み込みや再生を選ぶまでYouTubeストリームを遅らせる任意設定です。モバイル通信向けです。',
  'manual.dataSaverStep1':
    'ホーム下部の「ローカルデータ」、または練習画面の「モバイルデータを節約」から変更できます。',
  'manual.dataSaverStep2':
    'オンのままにすると先にポスターを表示し、動画を読み込む・プレビュー・再生のあとでストリームが始まります。',
  'manual.dataSaverStep3':
    '参照が表示されたらすぐプレーヤーを読み込みたい場合はオフにしてください。',
  'manual.dataSaverNote':
    '保存したURLはダウンロード済み動画ではありません。トグルはオンラインストリームの開始タイミングだけを制御します。',

  'manual.practiceTitle': '技を練習する',
  'manual.practiceLead':
    '日常練習は落ち着いた視聴画面です。技を選び、区間を見て、次へ進みます。',
  'manual.practiceStep1': '技を選びます。タイミング済みなら開始位置へシークします。',
  'manual.practiceStep2':
    '「区間再生」で開始から再生し終了付近で止めます。「リプレイ」は開始へ戻ります。',
  'manual.practiceStep3':
    '未設定の技も選べます — 全編視聴するか、エディタでタイミングを追加できます。',
  'manual.practiceStep4': '前へ / 次へ は演武順に沿い、端では無効になります。',

  'manual.judgeTitle': '演武を採点する',
  'manual.judgeLead':
    '練習採点では、パートナーやコーチがIJF風の基準で1回の演武を採点し、この端末に履歴を残せます。採点にYouTube参照は必須ではありません。',
  'manual.judgeStep1':
    '形の練習画面で「演武を採点」を開き、演武一覧（Performances）へ進みます。',
  'manual.judgeStep2':
    '「採点を開始」で新しい演武を始めるか、下書きがあれば「再開」します。',
  'manual.judgeStep3':
    '採点対象の要素を順に進めます。各観察項目で小（−1）・中（−3）・大（−5）をタップして減点を付けたり外したりします。',
  'manual.judgeStep4':
    '技が抜けているときは「忘れ／省略」を使います — その要素は0点になり、形の合計が半分になります。',
  'manual.judgeStep5':
    '要素ごとのコメントを残したり、「参照を見る」で同じ技の練習画面に戻れます（任意）。',
  'manual.judgeStep6':
    '終わったら「履歴に保存」。演武一覧から過去の採点を開き、合計や上達の推移を確認できます。',
  'manual.judgeNote':
    '練習用の補助であり、公式試合の結果ではありません。採点はこの端末に保存され、ローカルデータの書き出しに含まれます。',

  'manual.notesTitle': 'メモとお気に入り',
  'manual.notesLead': '練習画面を離れずに、技ごとの個人メモを残せます。',
  'manual.notesStep1': '技の「メモ」を開き、この端末に保存されるテキストを書きます。',
  'manual.notesStep2': '「お気に入り」で、すぐ見つけたい技をマークできます。',
  'manual.notesStep3': 'メモはあなた用の内容であり、HTMLとしては実行されません。',

  'manual.backupTitle': 'バックアップと復元',
  'manual.backupLead':
    '個人データはこのブラウザにあります。端末を替える前やサイトデータを消す前にJSONを書き出してください。',
  'manual.backupStep1': 'ホーム下部の「ローカルデータ」から開きます（ストレージ警告のあとでも可）。',
  'manual.backupStep2':
    'JSON書き出しで参照・タイミング・メモ・お気に入り・採点演武・設定をダウンロードします。',
  'manual.backupStep3':
    '取り込みは検証プレビューのあと個人データをすべて置換します — 必要なら先に書き出してください。「RESET」入力でリセットできます。',
  'manual.backupNote':
    'ブラウザやサイトデータを消すとローカル記録も消えることがあります。バックアップに動画ファイルは含まれません。',

  'manual.installTitle': 'インストールとオフライン',
  'manual.installLead':
    'ホーム画面に追加すると素早く開けます。一度読み込めば、アプリ本体はオフラインでも再開できます。',
  'manual.installStep1': 'ホームの「ホーム画面に追加」を、お使いのブラウザ手順で進めます。',
  'manual.installStep2':
    'インストール（または初回読み込み）後、UIと保存済みローカルデータはオフラインでも使えます。',
  'manual.installStep3':
    '新バージョンの準備ができたら、開いている編集を保存またはキャンセルしてから再読み込みします。',
  'manual.installNote':
    '保存したYouTube URLはダウンロード済み動画ではありません — 再生にはインターネットが必要です。',

  'data.title': 'ローカルデータ',
  'data.lead':
    'このブラウザに保存された個人データの書き出し・取り込み・リセット。動画ファイルは含まれません — YouTube参照、タイミング、メモ、お気に入り、設定のみです。',
  'data.prefsSaveFailed': '設定を保存できませんでした。もう一度お試しください。',
  'data.onDevice': 'この端末上',
  'data.references': '動画参照 {count} 件',
  'data.timings': '技タイミング {count} 件',
  'data.notes': 'メモ {count} 件',
  'data.favourites': 'お気に入り {count} 件',
  'data.performances': '採点演武 {count} 件',
  'data.loadingCounts': '件数を読み込み中…',
  'data.storageHint':
    'サイト/ブラウザデータを消すとこれらの記録も消えることがあります。ブラウザ保存は確実なバックアップではありません。',
  'data.export': '書き出し',
  'data.exportBody':
    '個人データのスキーマ版付きJSONバックアップをダウンロードします。取り込みやリセットの前に推奨します。',
  'data.exportJson': 'JSONを書き出し',
  'data.exportStatus':
    '参照 {references} 件、メモ {notes} 件、お気に入り {favourites} 件を書き出しました。ファイルはこの端末のみに保存されます。',
  'data.exportFailed': '書き出しに失敗しました。',
  'data.import': '取り込み（すべて置換）',
  'data.importBody':
    '書き込み前にファイル全体を検証します。成功した取り込みは現在の個人データを一括で置き換えます。無効なファイルでは既存データは変わりません。',
  'data.exportFirst': '先に現在のデータを書き出す',
  'data.chooseFile': 'JSONファイルを選択',
  'data.importPreview': '取り込みプレビュー',
  'data.importPreviewWarn': '確認すると、この端末の個人データがすべて置き換えられます。',
  'data.schemaExported': 'スキーマ v{version} · 書き出し {date}',
  'data.schemaOnly': 'スキーマ v{version}',
  'data.previewReferences': '参照 {count} 件',
  'data.previewTimings': 'タイミング {count} 件',
  'data.previewNotes': 'メモ {count} 件',
  'data.previewFavourites': 'お気に入り {count} 件',
  'data.previewPerformances': '採点演武 {count} 件',
  'data.preferencesIncluded': '設定: 含む',
  'data.preferencesEmpty': '設定: なし',
  'data.cancelImport': '取り込みをキャンセル',
  'data.confirmImport': 'すべて置換の取り込みを確認',
  'data.importConfirm':
    'この端末の個人データをすべて取り込み内容で置き換えますか？現在の参照、タイミング、メモ、お気に入り、設定は上書きされます。先にバックアップを書き出していない場合、元に戻せません。',
  'data.importApplied': '取り込みを適用しました。この端末の個人データは置き換えられました。',
  'data.importReadFailed': '取り込みファイルを読み込めませんでした。',
  'data.importWriteFailed': '取り込みの書き込みに失敗しました。以前のローカルデータは変わっていないはずです。',
  'data.reset': 'ローカルデータをリセット',
  'data.resetBody':
    'この端末の個人用参照、タイミング、メモ、お気に入り、設定を完全に削除します。形カタログは削除されません。',
  'data.resetLabel': '有効にするには RESET と入力',
  'data.resetButton': 'ローカル個人データをリセット',
  'data.resetTypeError': 'ローカルデータリセットを有効にするには確認欄に RESET と入力してください。',
  'data.resetConfirm':
    'この端末の個人用動画参照、タイミング、メモ、お気に入り、採点演武、設定をすべて削除しますか？技カタログは影響を受けません。元に戻せません。',
  'data.resetDone': 'この端末のローカル個人データをクリアしました。',
  'data.resetFailed': 'リセットに失敗しました。ローカルデータはクリアされていません。',
  'data.loadError': 'ローカルデータを読み込めませんでした。',

  'scoring.hubLabel': '練習採点',
  'scoring.hubTitle': '演武記録',
  'scoring.backPractice': '← 練習',
  'scoring.backPerformances': '← 演武記録',
  'scoring.newPerformance': '採点を始める',
  'scoring.resumeDraft': '進行中の採点を再開',
  'scoring.latest': '最新 {score} / {max}',
  'scoring.deltaUp': '前回比 +{delta}',
  'scoring.deltaDown': '前回比 {delta}',
  'scoring.improvement': '上達の推移',
  'scoring.improvementEmpty': '履歴に数回保存すると得点の推移が表示されます。',
  'scoring.past': '過去の演武',
  'scoring.empty': 'まだ採点演武がありません。練習採点を始めてください。',
  'scoring.statusComplete': '保存済み',
  'scoring.statusDraft': '進行中',
  'scoring.resume': '再開',
  'scoring.open': '開く',
  'scoring.delete': '削除',
  'scoring.deleteConfirm': 'この演武をこの端末から削除しますか？',
  'scoring.judgeLabel': '採点中',
  'scoring.scoreBar': '{total} / {max}',
  'scoring.reviewed': '確認済み {reviewed} / {total}',
  'scoring.halfPenaltyOn': '半減ペナルティ ON',
  'scoring.halfPenaltyOff': '半減ペナルティなし',
  'scoring.complete': '履歴に保存',
  'scoring.elements': '評価項目',
  'scoring.mistakesOnElement': 'この項目のミス — 重大度をタップして適用',
  'scoring.suggested': '目安 {kind}',
  'scoring.severitySmall': '小',
  'scoring.severityMedium': '中',
  'scoring.severityBig': '大',
  'scoring.forgotten': '失念 / 省略',
  'scoring.forgottenHint': 'この項目を 0 点にし、形の合計を半分にします。',
  'scoring.elementComment': '採点コメント（任意）',
  'scoring.elementCommentPlaceholder': 'この技・項目へのメモ…',
  'scoring.elementCommentHint': 'この項目のみに保存されます。演武全体のメモではありません。',
  'scoring.applied': '減点適用 → {points} / 10',
  'scoring.prevElement': '前の項目',
  'scoring.nextElement': '次の項目',
  'scoring.watchReference': '参考動画を見る',
  'scoring.completeTitle': 'この演武を保存',
  'scoring.scoredBy': '採点者（任意）',
  'scoring.note': 'メモ（任意）',
  'scoring.unreviewedWarn':
    '{count} 項目が未確認です。未確認は 10 点として計上されます。それでも履歴に保存しますか？',
  'scoring.saveComplete': '履歴に保存',
  'scoring.readOnly': '保存済み · 閲覧のみ',
  'scoring.duplicateNew': '新しく採点を始める',
  'scoring.unsupported': 'この形の練習採点はまだ利用できません。',
  'scoring.loadError': '採点データを読み込めませんでした。',
  'scoring.disclaimer':
    'IJF 形式の基準を用いた練習用ツールです。公式競技結果ではありません。基準文 © IJF Kata Commission。',
  'scoring.criteriaSourceLabel': '演武採点基準：',
  'scoring.criteriaNotifyCta': '新しい版があることを知らせる',
  'scoring.criteriaNotifySubject': 'IJF形採点基準の新しい版について',
  'scoring.criteriaNotifyBody':
    'こんにちは、\n\nアプリの演武採点基準は現在次の版を使っています：\n{title}\n{url}\n\nより新しい版が公開されています。\n\nよろしくお願いします。',
  'scoring.translationDisclaimer':
    '採点基準の翻訳は非公式であり、十分に正確でない場合があります。採点時は英文の基準に従ってください。',
  'scoring.showEnglishCriteria': '英文を表示',
  'scoring.showTranslatedCriteria': '翻訳を表示',
  'scoring.kindSmall': '小',
  'scoring.kindMedium': '中',
  'scoring.kindSmallMedium': '小/中',
  'scoring.kindBig': '大',
  'scoring.kindForgotten': '失念',

  'pwa.skipLink': 'メインコンテンツへスキップ',
  'pwa.offline':
    'オフラインです。アプリ本体と保存済みローカルデータは利用できます。YouTube再生にはインターネットが必要です — 保存されたURLはダウンロード済み動画ではありません。',
  'pwa.offlineReady':
    'オフライン利用の準備ができました。個人データはこのブラウザに残ります。動画再生には接続が必要です。',
  'pwa.persistDenied':
    'ストレージ不足時にブラウザがローカルデータを消すことがあります。必要に応じて「ローカルデータ」からバックアップを書き出してください。',
  'pwa.updateRegion': 'アプリの更新があります',
  'pwa.updateReady': '新しいバージョンの準備ができました。',
  'pwa.reload': '準備ができたら再読み込み',
  'pwa.notNow': 'あとで',
  'pwa.updateBlocked': 'アプリ更新の再読み込み前に、現在の編集を保存またはキャンセルしてください。',
}
